import * as Yup from "yup";

const SetupPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Too short")
    .max(30, "Too long")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords do not match")
    .required("Confirm password is required"),
});

export default SetupPasswordSchema;
